const OKMEvent_AfterSubmit = new Event('OKMEvent_AfterSubmit');
//const OKMEvent_BeforeSubmit = new Event('OKMEvent_BeforeSubmit');

async function submitForm(e) {
    e.preventDefault();
    const form = e.target;

    const phone_dialcode = form.querySelector( '#phone_dialcode-' + form.dataset.uuid );
    const phone_number = form.querySelector( '#phone_number-' + form.dataset.uuid );

    if ( phone_dialcode && phone_number )
    {
      let phone_final = form.querySelector( '#phone-' + form.dataset.uuid );
      let phone = phone_number.value;
      phone = phone.trim();
      if ( phone != "" && !phone.startsWith( phone_dialcode.innerText ) )
      {
        phone = phone_dialcode.innerText + phone.trim();
      }
      phone_final.value = phone;
    }
  
    const formData = new FormData(form);
    let jsonData = Object.fromEntries(formData.entries());
 
    if (!form.checkValidity()) return;
    
    try {   
      
      const OKMEvent_BeforeSubmit = new CustomEvent("OKMEvent_BeforeSubmit", {
        "detail": { "email": formData.get('email'), "phone": formData.get('phone') }
      });
      document.dispatchEvent( OKMEvent_BeforeSubmit );
      
      const response = await fetch(form.action, {method: 'POST', body: formData});
      const result = await response.json();

      if (result.success)
      {
        let user_email = form.okm_data.email ?? '';
        let user_phone = form.okm_data.phone ?? '';

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event':'okm_form_submission','form_name':form.okm_data.form_name,'email':user_email,'phone':user_phone});
        
        if ( form.okm_data.tracking_event && form.okm_data.tracking_event != '-' )
        {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({'event':form.okm_data.tracking_event,'form':form.okm_data.form_name,'email':user_email,'phone':user_phone});
        }

        const msg = document.getElementById( form.dataset.uuid + '-success' );
        if (form) form.classList.add('visually-hidden');
        if (msg) msg.classList.remove('visually-hidden');

        document.dispatchEvent( OKMEvent_AfterSubmit );
        //if ( form && form.okm_data && form.okm_data.redirect_url ) window.location.assign( form.okm_data.redirect_url );
      }
      else
      {
        const msg = document.getElementById( form.dataset.uuid + '-error' );
        if (msg)
        {
          let message = form.okm_data.msg_error;
          
          switch ( result.error )
          {
            case 'captcha':
              message = message.replace('{$err}', "Error verifying the form. Please try again." );
              break;
            case 'input':
              message = message.replace('{$err}', "Error validating your entries. Please try again." );
              break;
            default:
              message = message.replace('{$err}', "Error sending your request. Please try again." );
          }

          msg.innerHTML = message;
          form.classList.add('visually-hidden');
          msg.classList.remove('visually-hidden');
        }
      }
    }
    catch ( err )
    {
      const msg = document.getElementById( form.dataset.uuid + '-error' );
      if (msg)
      {
        msg.innerHTML = `Error sending your request. Please try again.`;
        msg.classList.remove('visually-hidden');
      }      
    }   
}

document.addEventListener('DOMContentLoaded', () => {
  'use strict'
  
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.querySelectorAll('.needs-validation');

  // Loop over them and prevent submission
  Array.from(forms).forEach(form => {

    const dropdownItems = form.querySelectorAll( '.dropdown-item' );
    const phone_dialcode = form.querySelector( '#phone_dialcode-' + form.dataset.uuid );
    const phone_country = form.querySelector( '#phone_country-' + form.dataset.uuid );
    const dropdownButton = form.querySelector( '#countryDropdown-' + form.dataset.uuid + ' img' );
    
    //let selectedDialCode = "+49";
  dropdownItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      const code = this.dataset.code;
      const title = this.dataset.title;
      const flag = this.dataset.flag;

      phone_dialcode.textContent = code;
      phone_country.textContent = title;
      dropdownButton.src = `https://flagcdn.com/${flag}`;
      //selectedDialCode = code;

      form.querySelector('#phone-' + form.dataset.uuid ).focus();
    });
  });
    
    const okm_tp = OKMCampaigns.read();
    if (okm_tp && form) {
        for (const key in okm_tp) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = okm_tp[key];
            form.appendChild(input);
        }
    }
    
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      }

      form.classList.add('was-validated')
    }, false)
  })
});